import { returnsDefaultDiscountByWeightSchema } from "@redotech/redo-fulfillment-rate-table-common/rate-table";
import * as z from "zod";

export const saveDefaultDiscountTable = {
  name: "saveDefaultDiscountTable" as const,
  input: z.object({ discountTable: returnsDefaultDiscountByWeightSchema }),
  output: z.object({ discountTable: returnsDefaultDiscountByWeightSchema }),
};
